import { useEffect, useState } from 'react';

/**
 * `open` says what the caller wants; `mounted` says what is on screen. A component cannot
 * animate its own removal while unmounting, so it stays mounted for `exitMs` after `open`
 * goes false, with `closing` set so it can play its exit animation.
 */
export function useExitTransition(open: boolean, exitMs: number): { mounted: boolean; closing: boolean } {
  const [mounted, setMounted] = useState(open);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (open) {
      setMounted(true);
      setClosing(false);
      return;
    }
    if (!mounted) return;

    setClosing(true);
    const timer = window.setTimeout(() => {
      setMounted(false);
      setClosing(false);
    }, exitMs);
    // Cleared if reopened mid-exit, which would otherwise unmount the fresh one a moment later.
    return () => window.clearTimeout(timer);
  }, [open, mounted, exitMs]);

  return { mounted, closing };
}
